export const reportColors = ['#ffcfc9', '#009688', '#c6dae1', '#ffe5a1', '#ff5722', '#ffc8aa', '#d4edbe', '#bee1f5', '#e5cff1', '#e7ebed', '#8f5d07'];
